/*
 * @Description: 数字相关的工具集
 * @Author: fiveonelei
 * @Date: 2022-01-25 16:53:35
 * @FilePath: /vise/packages/app-share/src/utils/number.ts
 */
export function addNumUint(num: number, lang?: 'cn') {
  const formatNum = parseInt(String(num | 0), 10);
  if (isNaN(formatNum)) return '';
  return formatNum >= 10000 ? `${Number(formatNum / 10000).toFixed(1)}${lang === 'cn' ? '万' : 'w'}` : String(formatNum);
}
